"use client";

import useTranslations from "../../hooks/useTranslation";
import useIsMobile from "../../hooks/useIsMobile";
import { useNavbar } from "../../contexts/NavbarContext";
// import '@/app/home-page/style..css'
import HomeSection from '../home-page/sections/homeSection/homeSection';
import FeaturesSection from '../home-page/sections/featuresSection/featureSection';
import TakingControl from '../home-page/sections/takingControlSection/takingControlSection';
import SuperChargeOrder from '../home-page/sections/superchargeOrderSection/superchargeOrder';
import GrowResto from '../home-page/sections/growRestoSection/growResto';
import OurProducts from '../home-page/sections/ourProducts/ourProducts';
import CustomApp from '../home-page/sections/customizableApp/customApp';
import MarketingPlatform from '../home-page/sections/marketingPlatformSection/marketing';
import Support from '../home-page/sections/supportSection/supportSection';
import CloudixPlayer from '../home-page/sections/cloudixPlayer/cloudixPlayer';
import Scroll from '../home-page/sections/scrollSection/scrollSection';

export default function HomeMain() {
    const {
        language,
        translations,
    } = useTranslations();

    const isMobile = useIsMobile();
    const { companyRef, productsRef, contactusRef, scrollToSection } = useNavbar();

    return (
        <>
            <div style={{ marginTop: "15rem", width: isMobile ? "100%" : "85%", margin: "auto", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <HomeSection
                    isMobile={isMobile}
                    language={language}
                    translations={translations}
                    scrollToSection={scrollToSection}
                    contactusRef={contactusRef} />
            </div>
            <div style={{ marginTop: "20px" }}>
                <FeaturesSection isMobile={isMobile} language={language} translations={translations} companyRef={companyRef} />
            </div>
            <div style={{ marginTop: "50px" }}>
                <TakingControl isMobile={isMobile} language={language} translations={translations} scrollToSection={scrollToSection}
                    contactusRef={contactusRef} />
            </div>
            <div style={{ width: isMobile ? "100%" : "85%", margin: "auto", display: "flex", flexDirection: "column", alignItems: "center" }}>
                <div style={{ marginTop: "20px" }}>
                    <SuperChargeOrder isMobile={isMobile} language={language} translations={translations} scrollToSection={scrollToSection}
                        contactusRef={contactusRef} />
                </div>
            </div>

            <div style={{ marginTop: "20px" }}>
                <GrowResto isMobile={isMobile} language={language} translations={translations} scrollToSection={scrollToSection}
                    contactusRef={contactusRef} />
            </div>
            <div style={{ width: isMobile ? "100%" : "85%", margin: "auto", display: "flex", flexDirection: "column", alignItems: "center" }}>
                <div style={{ marginTop: "20px", padding: "20px" }}>
                    <OurProducts isMobile={isMobile} language={language} translations={translations} productsRef={productsRef} />
                </div>
                <div style={{ marginTop: "20px", padding: "20px" }}>
                    <CustomApp language={language} translations={translations} />
                </div>
                <div style={{ marginTop: "20px", padding: isMobile ? "0px" : "20px", minHeight: "950px" }}>
                    <MarketingPlatform isMobile={isMobile} language={language} translations={translations} />
                </div>
                <div style={{ padding: "20px" }}>
                    <Support isMobile={isMobile} language={language} translations={translations} />
                </div>
                <div style={{ marginTop: "20px", padding: "20px" }}>
                    <CloudixPlayer isMobile={isMobile} language={language} translations={translations} />
                </div>
            </div>
            <div style={{ padding: "20px", marginTop: "20px" }}>
                <Scroll isMobile={isMobile} />
            </div>
        </>
    );
}
